import { useEffect, useState } from 'react';
import { PersonDetailsSection } from './PersonDetailsSection';
import { ContactsSection } from './ContactsSection';
import { AddressSection } from './AddressSection';
import { EmergencyContactsSection } from './EmergencyContactsSection';
import { getReferenceData, type ReferenceData } from '../workersApi';
import type { PersonDetailResponse } from '../workersApiTypes';

interface PersonalTabProps {
  person: PersonDetailResponse;
  personId: string;
  readOnly: boolean;
  onPersonUpdated: () => void;
}

// The Personal top-level tab hosts the four Person-layer sections (D-4). Each section manages its
// own data and editing flyout; Emergency Contacts is read-only (HR-mastered, BR-EC-002 / D-1).
export const PersonalTab = ({ person, personId, readOnly, onPersonUpdated }: PersonalTabProps) => {
  const [reference, setReference] = useState<ReferenceData | null>(null);

  useEffect(() => {
    let ignore = false;
    (async () => {
      const ref = await getReferenceData();
      if (!ignore) setReference(ref);
    })();
    return () => { ignore = true; };
  }, []);

  return (
    <div className="mgo-stack mgo-gap-l" style={{ paddingTop: 'var(--mgo-space-40)' }}>
      <PersonDetailsSection person={person} reference={reference} readOnly={readOnly} onUpdated={onPersonUpdated} />
      <ContactsSection personId={personId} reference={reference} readOnly={readOnly} />
      <AddressSection personId={personId} reference={reference} readOnly={readOnly} />
      <EmergencyContactsSection personId={personId} />
    </div>
  );
};
